import React, { useState } from 'react';
import CustomDropdown, { DropdownOption } from './custom-dropdown.component';


interface CurrencyInputProps {
  value?: number | string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  currency: string;
  onCurrencyChange: (cur: string) => void;
  currencies: string[];
  placeholder?: string;
  name?: string;
  type?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  currency,
  onCurrencyChange,
  currencies,
  placeholder,
  name,
  type = 'number',
  className = '',
  style = {},
}) => {
  const [isFocused, setIsFocused] = useState(false);
  
  // Convert currencies array to dropdown options
  const currencyOptions: DropdownOption[] = currencies.map(cur => ({
    value: cur,
    label: cur,
  }));

  return (
    <div className={`position-relative ${className}`} style={style}>
      <div 
        className="d-flex pl-3 align-items-center" 
        style={{
          border: isFocused ? '1px solid #a855f7' : '1px solid #EAEBF0',
          borderRadius: '12px',
          boxShadow: isFocused ? '0 0 0 3px rgba(168,85,247,0.18)' : 'none',
          transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
        }}
      >
        <input
          type={type}
          className="p-0 shadow-none py-2"
          placeholder={placeholder}
          name={name}
          value={value || ''}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{ flex: 1, border: 'none', outline: 'none', background: 'transparent', fontSize: '14px' }}
        />
        <div className="vr mx-2" />
        
        <CustomDropdown
          options={currencyOptions}
          value={currency}
          onSelect={onCurrencyChange}
          fullWidth={true}
          parentRelativeWidth={true}
          className="currency-dropdown"
        />
      </div>
    </div>
  );
};

export default CurrencyInput;
